<app-loader *ngIf="loading"></app-loader>
<app-progress *ngIf="downloadProgress" [progress]="downloadProgress"></app-progress>

<app-drawer [title]="getDrawerTitle()" [showDrawer]="createNewTrayFlag" (closeDrawer)="handleCloseDrawer($event)">

  <ng-container [ngSwitch]="true">

    <ng-container *ngSwitchCase="traysService.isTrayAllocation(allocationType)">
      <app-tray-form *ngIf="createNewTrayFlag" (closeSidenav)="handleCloseDrawer($event)">
      </app-tray-form>
    </ng-container>

    <ng-container *ngSwitchCase="traysService.isExtraTrayAllocation(allocationType)">
      <app-tray-form *ngIf="createNewTrayFlag" (closeSidenav)="handleCloseDrawer($event)" [isExtraTray]="true">
      </app-tray-form>
    </ng-container>

    <ng-container *ngSwitchCase="traysService.isShowcaseAllocation(allocationType)">
      <app-create-showcase-form *ngIf="createNewTrayFlag" (closeSidenav)="handleCloseDrawer($event)">
      </app-create-showcase-form>
    </ng-container>

  </ng-container>
</app-drawer>

<app-bulgari-filter [type]="getFilterType()" [hasSearch]="true" [hasSapCodeSearch]="true"
  (applyFilters)="search($event)" [selectOptions]="selectOptions" (resetFilters)="reset()"
  [placeholderSearch]="'PAGES.FILTER.SEARCH_FULL_TEXT'" [initialDate]="initialDate" (handleFiltersChange)="handleFiltersChange($event)" [loading]="loadingFiltersOptions">
</app-bulgari-filter>

<div class="tray-viewport-wrapper" cdkDropListGroup>

  <div class="tray-and-basket" [class.opened-basket]="collapsedBasket">

    <div class="basket-toggle" *ngIf="!isReadOnlyView()">
      <button (click)="collapsedBasket = !collapsedBasket">
        <h2 *ngIf="!collapsedBasket">
          {{'SWAP_AREA.TOGGLE.0' | translate}}
          <span class="counter">
            {{getBasketItemsCount()}}
          </span>
        </h2>
        <h2 *ngIf="collapsedBasket">
          {{'SWAP_AREA.TOGGLE.1' | translate}}
        </h2>

        <div class="basket-cta">
          <img [src]="'assets/images/black_arrow.svg'" alt="arrow" />
        </div>
      </button>
      <div class="infos" *ngIf="showFreeProductsCounter()">
        <span *ngIf="getFreeProductsCounter() > 0">
          {{'SWAP_AREA.FREE_PRODUCT_COUNTER1' | translate }}&nbsp;<b>{{getFreeProductsCounter()}}</b>
        </span>
        <span *ngIf="getFreeProductsCounter() === 0">
          {{'SWAP_AREA.FREE_PRODUCT_COUNTER2' | translate}}
        </span>
      </div>
    </div>

    <div class="wrapper">
      <div class="basket-viewport" *ngIf="!isReadOnlyView()">
        <div class="tray">
          <h2>
            {{'SWAP_AREA.TITLE' | translate}}
            <div class="ctas">
              <button class="cta select-all" [disabled]="!(getBasketItems().length>0)"
                [matTooltip]="'SWAP_AREA.SELECT_ALL' | translate" [matTooltipClass]="'table-tooltip'"
                (click)="selectAllProductsInBasket()">
                <img src="./assets/images/done_all.svg" alt="select all">
              </button>
              <button class="cta remove-all" [disabled]="!(getBasketItems().length>0)"
                [matTooltip]="'SWAP_AREA.EMPTY_ALL' | translate" [matTooltipClass]="'table-tooltip'"
                (click)="removeAllProductsFromBasket()">
                <img src="./assets/images/redo.svg" alt="redo">
              </button>
            </div>
            <span class="counter">
              {{getBasketItemsCount()}}
            </span>
          </h2>
          <div class="products">
            <ng-container *ngIf="getBasketItems().length > 0; else empty">
              <app-product *ngFor="let product of getBasketItems()" [product]="product"
                (handleRemoveProducts)="removeProductFromBasket($event)" [allocationType]="BASKET"
                [isSelected]="isSelectedProduct(product.sapCode)" [isInBasket]="false"
                (handleSelectProduct)="selectProductInBasket($event)">
              </app-product>
            </ng-container>
            <ng-template #empty>
              <span class="empty">{{'SWAP_AREA.EMPTY' | translate}}</span>
            </ng-template>
          </div>
        </div>

      </div>

      <div class="tray-viewport" (scroll)="onScroll($event)" cdkScrollable>

        <!-- <div *ngIf="showEmptyPlaceholder()" class="placeholder-empty-container free-products-tray">
          <img height="75px" src="../../../assets/images/placeholder_star.svg" alt="placeholder-star">
          <p class="text-placeholder"> {{ 'PAGES.PRODUCTS.TRAYS.NO_DATA' | translate}} </p>
        </div> -->

        <app-allocation-container *ngIf="canShowFreeProductsTray()" class="free-products-tray"
          [loading]="loadingFreeProducts" [readOnly]="isReadOnlyView()" [allocationType]="allocationType"
          [productsInBasket]="getBasketSapCodes()" [selectedProductsInBasket]="selectedProducts"
          [highlightedProducts]="highlightedProducts" [isFreeProductsTray]="true" [tray]="getFreeProductsTray()"
          (dropProduct)="moveProducts($event)" (openTrayDetail)="openDetail($event)"
          (removeProducts)="removeProducts($event)" (handleSelectProduct)="handleSelectProduct($event)"
          (handleMoveProductsFromBasket)="moveProductsFromBasket($event)">
        </app-allocation-container>

        <app-allocation-container *ngFor="let tray of getTrays()"
          [class.free-products-tray]="(tray.products && tray.products.length> 20)" [tray]="tray" [loading]="loading"
          [readOnly]="isReadOnlyView()" [allocationType]="allocationType" [productsInBasket]="getBasketSapCodes()"
          [selectedProductsInBasket]="selectedProducts" [highlightedProducts]="highlightedProducts"
          (dropProduct)="moveProducts($event)" (openTrayDetail)="openDetail($event)"
          (removeProducts)="removeProducts($event)" (handleSelectProduct)="handleSelectProduct($event)"
          (handleMoveProductsFromBasket)="moveProductsFromBasket($event)">
        </app-allocation-container>

      </div>
    </div>


  </div>

</div>
